import React from 'react';
import '../SpringLoader/spinner.css';
import { Row } from 'react-bootstrap';

const SpringLoader = ({ style }) => {
  return (
    <Row>
      <div className="half-circle-spinner" style={style}>
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
      </div>
    </Row>
  );
};

export default SpringLoader;
